import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/mypage/invoice-fail-inv.svg")